import { Route } from '@angular/router';

export const adminRoutes: Route[] = [
  {
    path: 'edc-resources/edc-list',
    loadComponent: () =>
      import('./edc-ressources-list/edc-ressources-list.component').then(
        (m) => m.EdcRessourcesListComponent
      ),
  },
  {
    path: 'edc-resources/cluster-management',
    loadComponent: () =>
      import('./cluster-management/cluster-management.component').then(
        (m) => m.ClusterManagementComponent
      ),
  },
];
